import { createFileRoute } from '@tanstack/react-router'
import { NewsCrawlerSettings } from '@/features/system-settings/news-crawler'

export const Route = createFileRoute(
  '/_authenticated/system-settings/content/news-crawler',
)({
  component: NewsCrawlerSettings,
})
